export default "__VITE_ASSET__oBVLR7dY__"